// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"27":"ff93262d","348":"0d1d3515","571":"b3184ef3","924":"5a6b114b"}[chunkId] + ".chunk.js";
};